<template>
    <div>
        <template v-if="hasNodes">
            <RecursiveTreeGroupedLinks  :nodes="nodes" ></RecursiveTreeGroupedLinks>
        </template>
        <template v-else-if="showEmptyMessage">
            <div class="text-center alert" :class="classEmptyMessage" role="alert">
                {{ $t(emptyMessage) }}
            </div>
        </template>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: 'TreeGroupedLinks',
        
        components: {
            RecursiveTreeGroupedLinks: () => import(/* webpackChunkName: "recursive-treeGroupedLinks" */ './RecursiveTreeGroupedLinks'),
        },
        props: {
            nodes: {
                type: Array,
                required: true,
            },
            showEmptyMessage: {
                type: Boolean,
                default: true,
            },
            emptyMessage: {
                type: String,
                default: 'global.no-data',
            },
            classEmptyMessage: {
                type: String,
                default: 'alert-light',
            }
        },
        data()
        {
            return {

            }
        },
        mounted() {

        },
        computed: {
            hasNodes() {
                return !!this.nodes.length;
            }
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped></style>
